<ng-template #modalLG let-modal>
    <div class="modal-header p-0" style="background-color: transparent;">
        <button type="button" class="close" style="margin-right: 5px" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div style="margin: 64px">
        <div class="modal-body p-0" tabindex="0" ngbAutofocus>
            <div class="text-center mb-2">
                <h5 style="font-size: 24px">Ajouter un client</h5>
                <p style="font-size: 15px" class="text-muted">Veuillez remplir tous ces champs nécessaires.</p>
            </div>
            <div class="center mb-2 wizard-content" >
                <div class="form-section rounded border-style d-flex">
                    <div class="option-card bordered" [ngClass]="{'selected': client.type === 'Individuel'}" (click)="selectClientType('Individuel')">
                        <div class="card-content d-flex flex-column align-items-center justify-content-center">
                            <div class="icon-title-container d-flex align-items-center justify-content-center">
                                <i data-feather="user" size="24"></i>
                                <span>Individuel</span>
                            </div>
                            <div class="org-radio-wrapper" [class.radio-checked]="client.type === 'Individuel'">
                                <input type="radio" id="individuel" name="clientType" value="Individuel" [(ngModel)]="client.type" (change)="validateForm()" class="org-radio-input">
                                <label class="org-radio-label" for="individuel"><span class="org-radio-dot"></span></label>
                            </div>
                        </div>
                    </div>
                    <div class="option-card bordered" [ngClass]="{'selected': client.type === 'Professionnel'}" (click)="selectClientType('Professionnel')">
                        <div class="card-content d-flex flex-column align-items-center justify-content-center">
                            <div class="icon-title-container d-flex align-items-center justify-content-center">
                                <i data-feather="briefcase" size="24"></i>
                                <span>Professionnel</span>
                            </div>
                            <div class="org-radio-wrapper" [class.radio-checked]="client.type === 'Professionnel'">
                                <input type="radio" id="professionnel" name="clientType" value="Professionnel" [(ngModel)]="client.type" (change)="validateForm()" class="org-radio-input">
                                <label class="org-radio-label" for="professionnel"><span class="org-radio-dot"></span></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="center mb-2" *ngIf="client.type === 'Professionnel'" style="margin-left: 10px">
                <label class="form-label" for="nom_entreprise">Nom de l'entreprise <span class="req" aria-required="true">*</span></label>
                <div class="input-group">
                    <input
                            type="text"
                            class="form-control"
                            id="nom_entreprise"
                            placeholder="Entrez le nom de l'entreprise"
                            [(ngModel)]="client.nom_entreprise"
                            name="nom_entreprise"
                            required
                            #nomEntrepriseControl="ngModel"
                            aria-required="true"
                            [ngClass]="{'is-invalid': nomEntrepriseControl.invalid && (nomEntrepriseControl.dirty || nomEntrepriseControl.touched)}"
                    />
                </div>
            </div>
            <div class="center mb-2"  style="margin-left: 10px">
                <label class="form-label">Civilité <span class="req" aria-required="true">*</span></label>
                <div class="d-flex align-items-center gap-4" [ngClass]="{'is-invalid': civiliteControl.invalid && (civiliteControl.dirty || civiliteControl.touched)}">
                    <label class="org-radio-option d-flex align-items-center gap-2" for="Homme">
                        <div class="org-radio-wrapper" style="padding: 0;">
                            <input type="radio" name="civilite" id="Homme" value="Homme" [(ngModel)]="client.civilite" required #civiliteControl="ngModel" aria-required="true" class="org-radio-input">
                            <span class="org-radio-label"><span class="org-radio-dot"></span></span>
                        </div>
                        <span class="form-label mb-0" style="font-size: 15px; margin: 0 22px 0 8px;">Homme</span>
                    </label>
                    <label class="org-radio-option d-flex align-items-center gap-2" for="Femme">
                        <div class="org-radio-wrapper" style="padding: 0;">
                            <input type="radio" name="civilite" id="Femme" value="Femme" [(ngModel)]="client.civilite" required aria-required="true" class="org-radio-input">
                            <span class="org-radio-label"><span class="org-radio-dot"></span></span>
                        </div>
                        <span class="form-label mb-0" style="font-size: 15px; margin-left: 8px;">Femme</span>
                    </label>
                </div>
            </div>
            <div class="center mb-2" style="margin-left: 10px">
                <label class="form-label" for="nom_prenom">Nom et Prénom <span class="req" aria-required="true">*</span></label>
                <div class="input-group">
                    <input
                            type="text"
                            class="form-control"
                            id="nom_prenom"
                            [(ngModel)]="client.nom_prenom"
                            name="nom_prenom"
                            required
                            #nomPrenomControl="ngModel"
                            aria-required="true"
                            [ngClass]="{'is-invalid': nomPrenomControl.invalid && (nomPrenomControl.dirty || nomPrenomControl.touched)}"
                    />
                </div>
            </div>
        </div>
        <div class="centerButtons">
            <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="!isFormValid" rippleEffect>
                Valider
            </button>
            <button type="button" class="btn annulerButton" (click)="modal.dismiss()" rippleEffect>Annuler</button>
        </div>
    </div>
</ng-template>
